var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-static-table',{attrs:{"items":_vm.mappedProviders,"fields":_vm.providersTableFields,"loading":_vm.loading,"show-search":""},on:{"item-click":_vm.onProviderClicked,"item-middle-click":_vm.onProviderMiddleClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }